import { useForkRef } from '@mui/material';
import { Tooltip, useElementIsEllipsis } from '@kc-console/common-ui';

import type { HTMLProps } from 'react';
import type { TooltipProps } from '@kc-console/common-ui';

export interface DataTableTableCellContent
  extends HTMLProps<HTMLSpanElement>,
    Pick<TooltipProps, 'message' | 'placement' | 'arrow' | 'whiteSpace'> {}

export default function DataTableTableCellContent(props: DataTableTableCellContent) {
  const { ref: refProp, message, placement, arrow, whiteSpace, children, ...others } = props;
  const { ref: ellipsisRef, isEllipsis } = useElementIsEllipsis();

  const ref = useForkRef(refProp, ellipsisRef);
  const tooltipMessage = isEllipsis ? children : undefined;

  return (
    <Tooltip
      message={message ?? tooltipMessage}
      placement={placement}
      arrow={arrow}
      whiteSpace={whiteSpace}
    >
      <span ref={ref} {...others}>
        {children}
      </span>
    </Tooltip>
  );
}
